import { IModelMapping } from "./generic/model.mapping";
import { ShippingPutRequestDtoModel } from "../models/shipping/dto/shipping-put-dto.model";
import { IShippingDtoModel } from "../models/shipping/dto/shipping.dto.model";
import { IDefaultShipToAddressModel } from "../models/shipping/shipping.model";
import { IShippingModel } from "../models/shipping//shipping.model";
import { ISavedAddressDetailsDtoModel } from "../models/saved-address/dto/saved-address-details-dto.model";
import { ISavedAddressDtoModel } from "../models/saved-address/dto/saved-address-dto.model";
import { ISavedShipToAddressPostDtoModel } from "../models/saved-address/dto/saved-ship-to-address-post-dto.model";
import { IJcontrolShippingMethodDtoModel } from "../models/legacy-info/jcontrol-customer-message-dto.model";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";

export class ShippingMapping implements IModelMapping<IShippingDtoModel, IShippingModel>  {
    toApplicationModel(resultDto: IShippingDtoModel): IShippingModel {
        return {
            defaultShipToAddress: resultDto.defaultShipToAddress ? {
                id: 'original',
                name: resultDto.defaultShipToAddress.details.name,
                addressLine1: resultDto.defaultShipToAddress.details.addressLine1,
                addressLine2: resultDto.defaultShipToAddress.details.addressLine2,
                townCity: resultDto.defaultShipToAddress.details.townCity,
                countryName: resultDto.defaultShipToAddress.details.countryName,
                countryCode: resultDto.defaultShipToAddress.details.countryCode,
                countyState: resultDto.defaultShipToAddress.details.countyState,
                postalCode: resultDto.defaultShipToAddress.details.postalCode,
                isResidentialAddress: resultDto.defaultShipToAddress.details.isResidentialAddress,
                isVerified: resultDto.defaultShipToAddress.details.isVerified,
                contactNumber: resultDto.defaultShipToAddress.details.contactNumber
            } as IDefaultShipToAddressModel : null,
            defaultShippingMethod: resultDto.defaultShippingMethodId ? {id: resultDto.defaultShippingMethodId} : null, //the api now gives us a flat id where previously it was an object, so map accordingly
            defaultShippingNote: resultDto.defaultShippingNote ? resultDto.defaultShippingNote : null,
            isApproveAnyShippingQuote: resultDto.isApproveAnyShippingQuote ? resultDto.isApproveAnyShippingQuote : null,
            defaultWarehouseInstructions: resultDto.defaultWarehouseInstructions ? resultDto.defaultWarehouseInstructions : null
        } as IShippingModel;
    }

    toDtoModel(model: IShippingModel): IShippingDtoModel {
        return {
            defaultShipToAddress: {
                id: model.defaultShipToAddress.id,
                details: {
                    addressLine1: model.defaultShipToAddress.addressLine1,
                    addressLine2: model.defaultShipToAddress.addressLine2,
                    townCity: model.defaultShipToAddress.townCity,
                    countyState: model.defaultShipToAddress.countyState,
                    countryCode: model.defaultShipToAddress.countryCode,
                    countryName: model.defaultShipToAddress.countryName,
                    isResidentialAddress: model.defaultShipToAddress.isResidentialAddress,
                    isVerified: model.defaultShipToAddress.isVerified,
                    contactNumber: model.defaultShipToAddress.contactNumber
                } as ISavedAddressDetailsDtoModel
            } as ISavedAddressDtoModel
        } as IShippingDtoModel;
    }

    toDtoModels(models: IShippingModel[]): IShippingDtoModel[] {
        return models.map(model => this.toDtoModel(model));
    }

    toApplicationModels(models: IShippingDtoModel[]): IShippingModel[] {
        return models.map(model => this.toApplicationModel(model));
    }

    toDtoPutModel(model: IShippingModel, customerId: string): ShippingPutRequestDtoModel {
        return {
            customerId: customerId,
            defaultShipToAddressId: model.defaultShipToAddress.id != 'new' && model.defaultShipToAddress.id != 'original' ? model.defaultShipToAddress.id : undefined,
            newShipToAddress: model.defaultShipToAddress && (model.defaultShipToAddress?.id && model.defaultShipToAddress.id == 'new') ? {
                name: model.defaultShipToAddress.name,
                addressLine1: model.defaultShipToAddress.addressLine1,
                addressLine2: model.defaultShipToAddress.addressLine2,
                townCity: model.defaultShipToAddress.townCity,
                countyState: model.defaultShipToAddress.countyState,
                postalCode: model.defaultShipToAddress.postalCode,
                countryCode: model.defaultShipToAddress.countryCode,
                countryName: model.defaultShipToAddress.countryName,
                isResidentialAddress: model.defaultShipToAddress.isResidentialAddress,
                isVerified: model.defaultShipToAddress.isVerified,
                contactNumber: model.defaultShipToAddress.contactNumber
            } as ISavedShipToAddressPostDtoModel : undefined,
            defaultShippingMethodId: model.defaultShippingMethod?.id,
            defaultShippingNote: model.defaultShippingNote,
            isApproveAnyShippingQuote: model.isApproveAnyShippingQuote,
            defaultWarehouseInstructions: model.defaultWarehouseInstructions
        }
    }

    toJControlShippingMethodModel(model: ILookUpType): IJcontrolShippingMethodDtoModel {
        return {
            id: model.id,
            name: model.title
        } as IJcontrolShippingMethodDtoModel
    }
}

